/** @jsx jsx */

import { Surface, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

const Styles = {
  container: css`
    padding: 20px 25px;
  `,
  list: css`
    list-style: disc;
    padding-left: 20px;
    margin-bottom: 0px;
  `,
  code: css`
    padding: 0px;
    background: none;
    font-size: inherit;
    border: none;
  `,
};

export default function AccountCreationHelp() {
  return (
    <Surface backgroundColor="GrayWarm2" borderColor="GrayWarm4">
      <aside css={Styles.container}>
        <Text margin="10px 0px" tag="h3" type="Body4">
          What is this?
        </Text>
        <Text>
          Login credentials for a permanent (non-trial) license account to your
          app’s user interface that supports using Zapier.
        </Text>
        <Text margin="20px 0px 10px" tag="h3" type="Body4">
          Create an account for us in your app
        </Text>
        <ul css={Styles.list}>
          <li>
            <Text>
              Set the account email & login to{' '}
              <code css={Styles.code}>integration-testing@zapier.com</code>
            </Text>
          </li>
          <li>
            <Text>
              Set the password to something secure{' '}
              <em>(we’ll update it later)</em>
            </Text>
          </li>
          <li>
            <Text>
              Include any notes or details we need to know about accessing your
              app as a user
            </Text>
          </li>
        </ul>
        <Text margin="20px 0px 10px" tag="p">
          <Link
            href={`${BASE_DOC_URL_VB}/publish/integration-publishing-requirements#7-1-application-has-a-valid-test-account`}
            target="_blank"
          >
            Learn more about the test account requirement.
          </Link>
        </Text>
      </aside>
    </Surface>
  );
}
